import { FOOTER_LINKS } from '../data/content';
import './Footer.scss';

/**
 * Footer — wordmark + sitemap columns + a small "made by" line.
 * Doesn't reveal-on-scroll because by this point the user has
 * already seen everything and the deliberate-fade-in would feel
 * sluggish.
 */
export function Footer() {
	return (
		<footer class="m-footer">
			<div class="m-footer__inner">
				<div class="m-footer__brand-col">
					<a class="m-footer__brand" href="/">
						<span class="m-footer__mark" aria-hidden="true">
							<span class="m-footer__mark-ring" />
							<span class="m-footer__mark-dot" />
						</span>
						<span class="m-footer__wordmark">pageloop</span>
					</a>
					<p class="m-footer__tagline">
						drop-in commenting and change-tracking for any web content — fully hosted,
						nothing to run.
					</p>
				</div>
				<div class="m-footer__cols">
					{FOOTER_LINKS.map((col) => (
						<div key={col.heading} class="m-footer__col">
							<h4 class="m-footer__col-h">{col.heading}</h4>
							<ul class="m-footer__col-list">
								{col.links.map((link) => (
									<li key={`${col.heading}:${link.label}`}>
										<a class="m-footer__link" href={link.href}>
											{link.label}
										</a>
									</li>
								))}
							</ul>
						</div>
					))}
				</div>
			</div>
			<div class="m-footer__bottom">
				<div class="m-footer__bottom-inner">
					<span>© {new Date().getFullYear()} PageLoop · All rights reserved</span>
					<span class="m-footer__bottom-sep">·</span>
					<span>made for people who'd rather comment in place than send screenshots</span>
				</div>
			</div>
		</footer>
	);
}
